import { Profile } from "../shared/profile.model";

export class CommunityMembership {
  id: string;
  community: string;
  member: Profile;
  invitedBy: Profile;
  role: string;
  createdAt: string;
  updatedAt: string;
}
